import {FlexRow} from '../../../components/utility/flex_row.tsx';
import {FlexColumn} from '../../../components/utility/flex_column.tsx';
import {Icon} from '../../../components/icon/icon.tsx';
import {Alignment} from '../../../enums/alignment.ts';
import {Widget} from '../../../components/widget/widget.tsx';
import {AltButton} from '../../../components/button/alt_button.tsx';
import {ButtonPosition} from '../../../enums/button_position.ts';
import {__} from '../../../support/lang/translations.ts';

interface OwnProps {
    unreadCount?: number;
}

export function UnreadMessagesWidget({unreadCount}: OwnProps) {
    if (unreadCount == null || unreadCount === 0) {
        return;
    }
    return (
        <Widget isInteractive={true} to="/chat">
            <FlexRow>
                <FlexColumn>
                    <FlexRow>
                        <Icon iconClassName="fa-regular fa-comment" outline={false} />
                        <FlexColumn>
                            <strong style={{marginLeft: '1rem'}}>
                                {__('dashboard.widgets.unread_messages.copy', {count: unreadCount?.toString()})}
                            </strong>
                        </FlexColumn>
                    </FlexRow>
                </FlexColumn>

                <FlexColumn alignment={Alignment.End}>
                    <AltButton position={ButtonPosition.Right}>
                        <i className="fa-light fa-arrow-right" />
                    </AltButton>
                </FlexColumn>
            </FlexRow>
        </Widget>
    );
}
